import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {DjPsycho} from "../../DjPsycho";
import {TimelineLite} from "gsap";
import {DjPsychoGameAssets} from "../../DjPsychoGameAssets";
import {DjPsychoSound} from "../../sound/DjPsychoSound";

export class DjPsychoOutroView extends PIXI.Container implements StageLayer {
    private _button: ContinueButton;
    private _clickCallback: any;
    private _totalWinText: PIXI.Text;
    private _amountWon: PIXI.BitmapText;
    private _spinsPlayedTxt: PIXI.Text;

    constructor() {
        super();
        this.name = "DjPsychoOutroView";
        this.init();
    }

    public onResize(): void {
        const bounds: ScreenBounds = NolimitApplication.screenBounds;
        if (NolimitApplication.isLandscape) {
            this._button.position.set(360, 615);
        } else {
            const centerBottom: number = (bounds.bottom - 610) * 0.5 + 610;
            this._button.position.set(360, centerBottom - 80);
        }
    }

    public showOutro(callback: Function): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            isBelowWinRestriction: boolean = DjPsycho.isWinBelowStake(),
            spinPlayed: number = DjPsycho.model.gameData.numberOfFreespinsPlayed,
            winNumber: number = DjPsycho.model.gameData.accumulatedRoundWin,
            isNoWin: boolean = (winNumber === 0.00);

        tl.add(() => {
            this._clickCallback = callback;
            this.onResize();
            DjPsycho.blackBgView.showBlackBg();
            this._totalWinText.visible = !(isBelowWinRestriction || isNoWin);

            // creating it again and again, since PIXI.Text is not good at memory optimisation.
            this._spinsPlayedTxt = new PIXI.Text((DjPsycho.apiPlugin.translations.translate("Spins Played:") + " " + spinPlayed), new PIXI.TextStyle(DjPsychoGameAssets.OUTRO_WIN_TEXT));
            this._spinsPlayedTxt.anchor.set(0.5);
            this._spinsPlayedTxt.position.set(360, 420);
            this.addChild(this._spinsPlayedTxt);

            this._amountWon.text = DjPsycho.apiPlugin.currency.formatValue(winNumber);
            if (this._amountWon.width > 700) {
                this._amountWon.width = 640;
            }
            this.alpha = 0;
            this.visible = true;
            if (!isBelowWinRestriction) {
                DjPsycho.soundPlayer.playFsEndCountUp();
            } else {
                // #174
                DjPsycho.soundPlayer.playSound(DjPsychoSound.COUNT_UP_ENDS_FS_BAD);
            }
            DjPsycho.keypadPlugin.setWin(winNumber, true, isBelowWinRestriction);
        });
        tl.to(this, {
            duration: 0.3,
            alpha: 1
        }, 0);

        // #174
        tl.add(() => {
            // #80
            DjPsycho.soundPlayer.fadeMusicOnOutro();
        }, 0.258);

        tl.add(() => {
            this._button.enable(true);
        });

        return tl;
    }

    private init(): void {
        this.visible = false;

        this._button = new ContinueButton();
        this._button.addClickCallback(() => {
            this.onButtonClick();
        });
        this._button.position.set(360, 615);
        this._button.pivot.set(this._button.width * 0.5, this._button.height * 0.5);
        this._button.enable(false);

        this._totalWinText = new PIXI.Text(DjPsycho.apiPlugin.translations.translate("Total Win"), new PIXI.TextStyle(DjPsychoGameAssets.OUTRO_WIN_TEXT));
        this._totalWinText.anchor.set(0.5);
        this._totalWinText.position.set(360, 150);

        this._amountWon = new PIXI.BitmapText(DjPsycho.apiPlugin.translations.translate(""), {
            fontName: DjPsychoGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 50,
            maxWidth: 620
        });
        this._amountWon.position.set(360, 230);
        this._amountWon.anchor = new PIXI.Point(0.5, 0.5);

        this.onResize();
        this.addChild(this._button, this._totalWinText, this._amountWon);
    }

    private onButtonClick(): void {
        const tl: TimelineLite = new TimelineLite();

        tl.add(() => {
            DjPsycho.backgroundElements.setMode();
            DjPsycho.xBetView.removeButton(true);
            this._button.enable(false);
            DjPsycho.blackBgView.onComplete();
            DjPsycho.miniCollectors.onExitingBonusGame();

            // #50
            DjPsycho.soundPlayer.switchMusic(DjPsycho.model.gameData.nextMode);
        }, 0);
        tl.to(this, {
            duration: 0.4,
            alpha: 0
        }, 0);

        tl.add(() => {
            DjPsycho.popUpView.showPopUp();
            this.visible = false;
            this.alpha = 1;

            this._spinsPlayedTxt.destroy({
                children: true,
                texture: true,
                baseTexture: true
            });

            this?._clickCallback();
            delete this._clickCallback;
        });
    }
}